<template>
  <div class="teacher-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="left">
        <img
          class="teacher-img"
          src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/xxy.jpeg"
          alt=""
        />
        <div class="bold-desc">Assistant Professor</div>
        <div class="email-desc">yixingx@hdu.edu.cn</div>
      </div>
      <div class="right">
        <div class="bold-title">个人介绍 INTRODUCTION</div>

        <div class="right-content">
          <p class="para">
            <strong>夏一行</strong
            >,杭州电子科技大学计算机学院讲师，2007年博士毕业于浙江大学。
          </p>
          <p class="para">
            主要研究领域为<strong>类脑计算、计算神经科学、计算机科学与软件</strong>等，主持和参与多项浙江省自然科学基金、浙江省重点研发项目、浙江省公益计划项目等，是国家级线上线下混合式一流课程的主要成员，长期从事<strong>翻转课堂教学</strong>的研究应用。
          </p>
        </div>
        <div class="bold-title">科研项目 PROJECTS</div>
        <div class="right-content">
          ●
          浙江省公益技术研究工业项目：“小型化超高频RFID读写器关键技术研究”(2012C21043)，2012-01至2014-01，15万(已结题，主持)；
          <br />● 公益技术研究社会发展项目：“科技项目评审专家智能推荐系统研究”
          (2015C33066)，2015-06至2017-05，20万(已结题，主持)； <br />●
          浙江省自然科学基金一般项目:“基于神经拟态模型的并发数据流异常检测技术研究”(LY17F020028),2017-01至2019-12，8万(已结题,主持)。
        </div>
        <div class="bold-title">发表论文 SELECTED PUBLICATIONS</div>
        <div class="right-content">
          ● Xiaoliang Xu, Wensi Lu, Qiming Fang, Yixing Xia. A Visual
          Recognition Model Based on Hierarchical Feature Extraction and
          Multi-layer SNN. The 25th International Conference on Neural
          Information Processing (ICONIP 2018), Siem Reap, Cambodia. Dec 13-16,
          2018. pp. 525~534.（CCF C）
          <br />● Yuxiang Wang, Yixing Xia, Qiming Fang, Xiaoliang Xu*. AQP++: a
          hybrid approximate query processing framework for generalized
          aggregation queries. Journal of computational science (JOCS), 2018,
          26: 419-431. (JCR R3) <br />●
          夏一行，“基于MOOCs的程序设计课程翻转课堂教学改革”，杭州电子科技大学学报（自然科学版），2014。
          <br />● Yixing Xia, Xiaoliang Xu, “Reusable Components Design for
          Embedded Digital Instrumentation Software Systems”， World Congress on
          Software Enigineering (WCSE2009)，IEEE Computer Society, May 2009.
          <br />● Xia Yi-xing, Chen Yao-wu, “A Component-based Framework for
          Embedded Digital Instrumentation Software with Design Patterns”，8th
          ACIS International Conference on Software Engineering, Artificial
          Intelligence, Networking, and Parallel/Distributed Computing
          (SNPD2007)，IEEE Computer Society, July 2007.
        </div>

        <div class="bold-title">其他获奖/荣誉 Rewards</div>
        <div class="right-content">
          ●
          杭州电子科技大学校级教学成果一等奖:“课内外联动，理论实践交融”-程序设计课程教学研究与实践,，2/5，2016；
          <br />●
          浙江省高校首批翻转课堂优秀案例特等奖：C语言程序设计，1/3，2017；
          <br />●
          浙江省高校“互联网+”优秀教学案例特等奖：C语言程序设计，2/5，2019。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.teacher-container {
  min-height: 100vh;
}
.item-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  padding-top: 60px;
}
.item-background {
  height: 60px;
}
.left {
  width: 15%;
}
.right {
  width: 85%;
  padding-left: 40px;
}
.teacher-img {
  width: 100%;
}
.bold-desc {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 20px;
}
.email-desc {
  text-align: center;
  color: #03a9f4;
  font-size: 20px;
}
.bold-title {
  color: #4f81bd;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.right-content {
  font-size: 20px;
  line-height: 36px;
}
@media screen and (max-width: 900px) {
  .item-container {
    display: block;
  }
  .left {
    width: 100%;
    text-align: center;
  }
  .right {
    width: 100%;
  }
  .teacher-img {
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/teacher/xiayixing.vue